import { BULK_SPLITER } from '@openx/components-targeting/Targeting/shared/BulkAdd/utils.ts';
import type { ListData } from '@openx/types/inventoryList.ts';

export const formatDataForValidation = (listData: ListData[], bulkInput: string) => {
  const dataFromState = listData.map(item => item.name);
  const dataFromInput = bulkInput
    .split(BULK_SPLITER)
    .map(value => value.trim())
    .filter(Boolean);

  return { dataFromState, dataFromInput };
};
